import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { get_serializableProperties2tbouuwr11am9 as get_serializableProperties } from './SerializableProperty.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { nullElementzitp7se36veh as nullElement } from './SerializationHelpers.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  Exceptiondt2hlxn7j7vw as Exception,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { get_elementNamesl5b6t976dltd as get_elementNames } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptor.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { buildClassSerialDescriptors2a6xdp6mrtw as buildClassSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptors.mjs';
import { LazyRenamedSerialDescriptor35xsl6h8pjd6j as LazyRenamedSerialDescriptor } from '../lightningdb/ConditionSerialization.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { Partialk1npfnymwip2 as Partial } from './Partial.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _get_childSerializers__7vnyfa($this) {
  var tmp0 = $this.m4r_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('childSerializers', 1, tmp, PartialSerializer$_get_childSerializers_$ref_w8t6cm(), null);
  return tmp0.f2();
}
function _get_innerDescriptor__gn4218($this) {
  var tmp0 = $this.n4r_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('innerDescriptor', 1, tmp, PartialSerializer$_get_innerDescriptor_$ref_rjrmfq(), null);
  return tmp0.f2();
}
function PartialSerializer$_get_childSerializers_$ref_w8t6cm() {
  return (p0) => _get_childSerializers__7vnyfa(p0);
}
function PartialSerializer$innerDescriptor$delegate$lambda$lambda$lambda(it) {
  return it.az().h10();
}
function PartialSerializer$_get_innerDescriptor_$ref_rjrmfq() {
  return (p0) => _get_innerDescriptor__gn4218(p0);
}
var PartialSerializerClass;
function PartialSerializer() {
  if (PartialSerializerClass === VOID) {
    class $ {
      constructor(source) {
        this.l4r_1 = source;
        var tmp = this;
        tmp.m4r_1 = lazy(() => {
          var tmp0_safe_receiver = get_serializableProperties(this.l4r_1);
          var tmp;
          if (tmp0_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'kotlin.collections.map' call
            // Inline function 'kotlin.collections.mapTo' call
            var destination = ArrayList().u(tmp0_safe_receiver.length);
            var inductionVariable = 0;
            var last = tmp0_safe_receiver.length;
            while (inductionVariable < last) {
              var item = tmp0_safe_receiver[inductionVariable];
              inductionVariable = inductionVariable + 1 | 0;
              var tmp_0;
              if (item.j2j().az().l11()) {
                var nn = ensureNotNull(nullElement(item.j2j()));
                var tmp_1;
                if (!(get_serializableProperties(nn) == null)) {
                  tmp_1 = equals(nn, this.l4r_1) ? get_nullable(this) : get_nullable(new (PartialSerializer())(nn));
                } else {
                  tmp_1 = item.j2j();
                }
                tmp_0 = tmp_1;
              } else {
                var tmp_2;
                if (!(get_serializableProperties(item.j2j()) == null)) {
                  tmp_2 = equals(item.j2j(), this.l4r_1) ? this : new (PartialSerializer())(item.j2j());
                } else {
                  tmp_2 = item.j2j();
                }
                tmp_0 = tmp_2;
              }
              var tmp$ret$0 = tmp_0;
              destination.v(tmp$ret$0);
            }
            tmp = destination;
          }
          var tmp1_elvis_lhs = tmp;
          var tmp_3;
          if (tmp1_elvis_lhs == null) {
            var tmp_4;
            if (this.l4r_1.az().h10() === 'kotlin.Nothing') {
              // Inline function 'kotlin.collections.listOf' call
              tmp_4 = emptyList();
            } else {
              throw IllegalArgumentException().a1('Failed to make partial serializer: ' + this.l4r_1.az().h10() + ' has no serializableProperties');
            }
            tmp_3 = tmp_4;
          } else {
            tmp_3 = tmp1_elvis_lhs;
          }
          return tmp_3;
        });
        var tmp_0 = this;
        tmp_0.n4r_1 = lazy(() => {
          var tmp;
          try {
            var sourceDescriptor = this.l4r_1.az();
            tmp = buildClassSerialDescriptor('com.lightningkite.serialization.Partial', [sourceDescriptor], ($this$buildClassSerialDescriptor) => {
              var tmp;
              if (!(sourceDescriptor.u11() === _get_childSerializers__7vnyfa(this).p1())) {
                var tmp_0 = sourceDescriptor.u11();
                var tmp_1 = _get_childSerializers__7vnyfa(this).p1();
                var tmp_2 = joinToString(get_elementNames(sourceDescriptor));
                var tmp_3 = _get_childSerializers__7vnyfa(this);
                throw IllegalStateException().o4('Mismatch in child serializer count; ' + tmp_0 + ' vs ' + tmp_1 + '; ' + tmp_2 + ' vs ' + joinToString(tmp_3, VOID, VOID, VOID, VOID, VOID, PartialSerializer$innerDescriptor$delegate$lambda$lambda$lambda));
              }
              var inductionVariable = 0;
              var last = sourceDescriptor.u11();
              var tmp_4;
              if (inductionVariable < last) {
                do {
                  var index = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var s = _get_childSerializers__7vnyfa(this).q1(index);
                  if (s instanceof PartialSerializer()) {
                    $this$buildClassSerialDescriptor.g12(sourceDescriptor.v11(index), s.o4r_1, sourceDescriptor.x11(index), true);
                  } else {
                    $this$buildClassSerialDescriptor.g12(sourceDescriptor.v11(index), sourceDescriptor.y11(index), sourceDescriptor.x11(index), true);
                  }
                }
                 while (inductionVariable < last);
                tmp_4 = Unit_instance;
              }
              return Unit_instance;
            });
          } catch ($p) {
            var tmp_0;
            if ($p instanceof Exception()) {
              var e = $p;
              throw Exception().vd('Failed to make partial descriptor for ' + this.l4r_1.az().h10(), e);
            } else {
              throw $p;
            }
          }
          return tmp;
        });
        var tmp_1 = this;
        tmp_1.o4r_1 = new (LazyRenamedSerialDescriptor())('com.lightningkite.serialization.Partial', () => _get_innerDescriptor__gn4218(this));
      }
      az() {
        return this.o4r_1;
      }
      pz(decoder) {
        // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
        var descriptor = this.o4r_1;
        var composite = decoder.l13(descriptor);
        var out = HashMap().n8();
        $l$loop_0: while (true) {
          var index = composite.b14(this.o4r_1);
          switch (index) {
            case -1:
              break $l$loop_0;
            case -3:
              continue $l$loop_0;
            default:
              // Inline function 'kotlin.collections.find' call

              var tmp0 = ensureNotNull(get_serializableProperties(this.l4r_1));
              var tmp$ret$1;
              $l$block: {
                // Inline function 'kotlin.collections.firstOrNull' call
                var inductionVariable = 0;
                var last = tmp0.length;
                while (inductionVariable < last) {
                  var element = tmp0[inductionVariable];
                  inductionVariable = inductionVariable + 1 | 0;
                  if (element.k20() === this.o4r_1.v11(index)) {
                    tmp$ret$1 = element;
                    break $l$block;
                  }
                }
                tmp$ret$1 = null;
              }

              var tmp$ret$2 = tmp$ret$1;
              var tmp2 = ensureNotNull(tmp$ret$2);
              // Inline function 'kotlin.collections.set' call

              var value = composite.y13(this.o4r_1, index, _get_childSerializers__7vnyfa(this).q1(index));
              out.s3(tmp2, value);
              break;
          }
        }
        var result = new (Partial())(out);
        composite.m13(descriptor);
        return result;
      }
      p4r(encoder, value) {
        // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
        var descriptor = this.o4r_1;
        var composite = encoder.l13(descriptor);
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s = value.k4r_1.d2().m1();
        while (_iterator__ex2g4s.n1()) {
          var _destruct__k2r9zo = _iterator__ex2g4s.o1();
          // Inline function 'kotlin.collections.component1' call
          var key = _destruct__k2r9zo.e2();
          // Inline function 'kotlin.collections.component2' call
          var v = _destruct__k2r9zo.f2();
          var index = this.o4r_1.w11(key.k20());
          var tmp = _get_childSerializers__7vnyfa(this).q1(index);
          composite.c15(this.o4r_1, index, isInterface(tmp, KSerializer()) ? tmp : THROW_CCE(), v);
        }
        composite.m13(descriptor);
        return Unit_instance;
      }
      oz(encoder, value) {
        return this.p4r(encoder, value instanceof Partial() ? value : THROW_CCE());
      }
    }
    initMetadataForClass($, 'PartialSerializer', VOID, VOID, [KSerializer()]);
    PartialSerializerClass = $;
  }
  return PartialSerializerClass;
}
//region block: exports
export {
  PartialSerializer as PartialSerializer6novagrzu32x,
};
//endregion

//# sourceMappingURL=PartialSerializer.mjs.map
